import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Button from "../../../../../components/Button";
import { AuthContext } from '../../../../../contexts/AuthContext';
import { Modules, AuthRoutes, RouteParamsTypes, PermissionModulesEnum, PermissionActionsEnum } from "../../../../../enums";
import { hasResourseAccess } from '../../../../../utils/methods';

interface HeaderProps {
  id?: string;
  view: boolean;
  edit: boolean;
  loading: boolean;
}

const Header: React.FC<HeaderProps> = ({ id, view, edit, loading }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { isSystemAdmin, permissions } = useContext(AuthContext);

  const hasAddAccess = hasResourseAccess(isSystemAdmin, permissions, { accessibleTo: [{ [PermissionModulesEnum.Property]: [PermissionActionsEnum.Add] }] })
  const hasEditAccess = hasResourseAccess(isSystemAdmin, permissions, { accessibleTo: [{ [PermissionModulesEnum.Property]: [PermissionActionsEnum.Update] }] })
  const hasListAccess = hasResourseAccess(isSystemAdmin, permissions, { accessibleTo: [{ [PermissionModulesEnum.Property]: [PermissionActionsEnum.View] }] })

  const handleGoToListClick = () => {
    navigate(Modules.resources + AuthRoutes.properties);
  };

  const handleEditButtonClick = () => {
    navigate(`${Modules.resources}${AuthRoutes.properties}${RouteParamsTypes.edit}/${id}`);
  }

  const handleAddNewClick = () => {
    navigate(Modules.resources + AuthRoutes.properties + RouteParamsTypes.add);
  };

  return (
    <div className="row mb-6">
      <div className="col-6">
        <h4 className="m-0 fw-bold">{t('property.addEdit.pageTexts.header.title')}</h4>
        <p>{t('property.addEdit.pageTexts.header.subTitle')}</p>
      </div>
      <div className="col-6 d-flex align-items-center justify-content-end gap-3">
        {
          edit && hasAddAccess && (
            <Button
              className="btn btn-primary waves-effect waves-light mt-xs-3"
              text={t("property.addEdit.pageTexts.header.addNew")}
              onClick={handleAddNewClick}
            />
          )
        }

        {
          view && !loading && hasEditAccess && (
            <Button
              className="btn btn-primary waves-effect waves-light mt-xs-3"
              text={t("property.addEdit.pageTexts.header.editBtn")}
              onClick={() => handleEditButtonClick()}
            />
          )
        }

        {
          hasListAccess && (
            <Button
              className="btn btn-primary waves-effect waves-light"
              onClick={handleGoToListClick}
              text={t("property.addEdit.pageTexts.header.goToList")}
            />
          )
        }
      </div>
    </div>
  );
}

export default Header;